import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
        try {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        } catch (e) {
            document.documentElement.scrollTo(0, 0);
        }
    }, [location.pathname, location.search]);
    return children;
};

export default ScrollToTop;
